import callApi from 'lib/callApi';

export async function fetchRepositoryDetail(id, companyId) {
  let url = `sast/repositories/${id}/`;
  const params = {
    company_id: companyId,
  };
  const data = await callApi(url, 'GET', params)
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}

export const processJsonData = (json: any) => {
  if (!json) return;

  // process fullname
  let fullname: any = null;
  if (
    json['added_by'] &&
    json['added_by']['first_name'] &&
    json['added_by']['last_name']
  ) {
    fullname = `${json['added_by']['first_name']} ${json['added_by']['last_name']}`;
  }

  let accountFullname: any = null;
  if (
    json['account'] &&
    json['account']['user'] &&
    json['account']['user']['first_name'] &&
    json['account']['user']['last_name']
  ) {
    accountFullname = `${json['account']['user']['first_name']} ${json['account']['user']['last_name']}`;
  }

  let deactivatedByFullName: any = null;
  if (
    json['deactivated_by'] &&
    json['deactivated_by']['first_name'] &&
    json['deactivated_by']['last_name']
  ) {
    deactivatedByFullName = `${json['deactivated_by']['first_name']} ${json['deactivated_by']['last_name']}`;
  }

  let reactivatedByFullName: any = null;
  if (
    json['reactivated_by'] &&
    json['reactivated_by']['first_name'] &&
    json['reactivated_by']['last_name']
  ) {
    reactivatedByFullName = `${json['reactivated_by']['first_name']} ${json['reactivated_by']['last_name']}`;
  }

  let supportedLanguages: any = null;
  if (json['languages'] && json['languages']['supported_languages']) {
    supportedLanguages = `${json['languages']['supported_languages'].join(
      ', ',
    )}`;
  }

  let unsupportedLanguages: any = null;
  if (json['languages'] && json['languages']['unsupported_languages']) {
    unsupportedLanguages = `${json['languages']['unsupported_languages'].join(
      ', ',
    )}`;
  }

  const processedJson = {
    ...json,
    account: {
      ...json['account'],
      user: {
        ...json['account']['user'],
        fullname: accountFullname,
      },
    },
    added_by: {
      ...json['added_by'],
      fullname: fullname,
    },
    deactivated_by: {
      ...json['deactivated_by'],
      fullname: deactivatedByFullName,
    },
    reactivated_by: {
      ...json['reactivated_by'],
      fullname: reactivatedByFullName,
    },
    languages: {
      ...json['languages'],
      supported_languages: supportedLanguages,
      unsupported_languages: unsupportedLanguages,
    },
  };

  return processedJson;
};

export function getExportCsvUrlParams(
  companyId: number,
  ordering: string,
  accountIds: number[],
  hostTypes: string[],
  stateFilters: string[],
  checkedHostIds: number[],
) {
  if (companyId === -1) return '';
  const params = {
    company_id: companyId,
    host_types: hostTypes.join(','),
    account_ids: accountIds.join(','),
    state_filters: stateFilters.join(','),
  };
  if (checkedHostIds?.length > 0) {
    params['host_id_list'] = checkedHostIds;
  }
  if (ordering && ordering !== 'name') {
    params['ordering'] = `${ordering},name`;
  }

  return params;
}
